var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3184 3.45508H3.60367C2.72002 3.45508 2.71875 3.472 2.71875 4.36067V17.2964C2.71875 18.1987 2.71983 18.1987 3.60348 18.1987H16.3198C17.1188 18.1987 17.1188 18.1987 17.1184 17.3806V4.29044C17.1184 3.45508 17.1184 3.45508 16.3184 3.45508Z",
    stroke: "#1E1D1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 16,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.2031 1.81836V5.09109",
    stroke: "#1E1D1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.79688 1.81836V5.09109",
    stroke: "#1E1D1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 16,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.79688 8.36328H16.3969",
    stroke: "#1E1D1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4557d48f0e1620e3d1de62c9e29eecc1.svg";
export { ForwardRef as ReactComponent };